import React, { Component, useEffect, useState } from "react";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { formatAmount, getAllMonths, getAllYears, getFieldData } from "../../Services/appService";
import GeneratePdf from "../../app/components/Report/GeneratePdf";
import { getCurrentUser, getLoggedUserDetails, loadUserDetails } from "../../app/store/auth";
import { useDispatch, useSelector } from "react-redux";
import { getFilterAllCandidates, loadCandidatesByFilter } from "../../app/store/candidate";
import { getMonthlyPayCandidates, loadMonthlyPayCandidates } from "../../app/store/report";
import { getPartnerAllCandidate, loadPartnerAllCandidate } from "../../app/store/partner";

const CustomReport = () => {

  const years = getAllYears();
  const months = getAllMonths();

  const [selectedYear, setSelectedYear] = useState("");
  const [candidateList, setCandidateList] = useState([]);
  const [monthlyRpt, setMonthlyRpt] = useState([]);
  const [allRpts, setAllRpts] = useState([]);
  const [pdfShowHide, setPdfShowHide] = useState(false);
  const [selectedCol, setSelectedCol] = useState([]);
  const [selectedColData, setSelectedColData] = useState([]);
  const [userDetails, setUserDeatils] = useState([]);
  const [candidateObj, setcandidateObj] = useState(null);
  const [candidateEntity, setCandidateEntity] = useState(null);

  const userDetailsSelector = useSelector(getLoggedUserDetails);
  const filterAllCandidatesSelector = useSelector(getFilterAllCandidates);
  const monthlyPayCandidatesSelector = useSelector(getMonthlyPayCandidates);
  const partnerAllCandidateSelector = useSelector(getPartnerAllCandidate);

  const usrType = localStorage.getItem("userType");

  const currentUser = getCurrentUser();
  const dispatch = useDispatch();

  useEffect(() => {
    let usrId = currentUser.id;
    if (currentUser.linkUser)
      usrId = currentUser.linkUser;
    if (!userDetailsSelector)
      dispatch(loadUserDetails(usrId));
  }, []);

  useEffect(() => {
    if (userDetailsSelector) {
      setUserDeatils(userDetailsSelector);
      if (usrType === "candidate")
        getCandidateDetails(currentUser.id);
      else if (userDetailsSelector?.approved > 0)
        dispatch(loadPartnerAllCandidate(userDetailsSelector.partnerid, 0))
    }
  }, [userDetailsSelector]);

  useEffect(() => {
    setCandidateList(partnerAllCandidateSelector);
  }, [partnerAllCandidateSelector])



  const getCandidateDetails = (id) => {
    const frmBody = new FormData();
    frmBody.append("id", id);
    frmBody.append("name", "");
    frmBody.append("email", "");
    frmBody.append("entity", "");
    frmBody.append("type", "candidate");
    frmBody.append("filterType", "single");
    dispatch(loadCandidatesByFilter(frmBody))
  };

  useEffect(() => {
    if (filterAllCandidatesSelector.length > 0) {
      const candidate = filterAllCandidatesSelector[0];

      setcandidateObj(candidate);

      const entityType = getFieldData(
        candidate.performerData,
        "candidateonboardingform",
        "CandidateEntity"
      );

      let rptType = "candidate";
      if (entityType === "C2C Basis") rptType = "subcontractor";
      if (userDetails?.partnerType === "Recruiter") rptType = "recruiter";

      setCandidateEntity(entityType)
      dispatch(loadMonthlyPayCandidates(candidate.id, rptType))

    }
  }, [filterAllCandidatesSelector]);

  useEffect(() => {
    if (monthlyPayCandidatesSelector.length > 0) {

      setAllRpts(monthlyPayCandidatesSelector);

      let filterRpt = monthlyPayCandidatesSelector;
      if (selectedYear !== "")
        filterRpt = filterRpt.filter((x) => x.year === parseInt(selectedYear));

      setMonthlyRpt(filterRpt);
    }
  }, [monthlyPayCandidatesSelector])

  const handleCandidateChange = ({ currentTarget }) => {
    setMonthlyRpt([]);
    setAllRpts([]);
    setSelectedYear("");
    if (currentTarget.value !== "")
      getCandidateDetails(currentTarget.value);
  };

  const handleChangeYear = ({ currentTarget }) => {
    if (currentTarget.value !== "") {
      const rtps = allRpts.filter(
        (x) => x.year === parseInt(currentTarget.value)
      );
      setMonthlyRpt(rtps);
      setSelectedYear(currentTarget.value);
    } else {
      setMonthlyRpt(allRpts);
      setSelectedYear("");
    }
  };

  const getTotalRows = () => {
    let hrs = 0;
    let min = 0;
    let invAmt = 0;
    let payAmt = 0;
    let adPlusAmt = 0;
    let adMinAmt = 0;
    let adpAmt = 0;

    monthlyRpt.forEach((item) => {
      hrs += Number(item.hours) || 0;
      min += Number(item.minutes) || 0;
      invAmt += Number(item.totalAmount) || 0;
      payAmt += Number(item.paidAmount) || 0;
      adPlusAmt += Number(item.adjustPlus) || 0;
      adMinAmt += Number(item.adjustMinus) || 0;
      adpAmt += Number(item.adpDeduction) || 0;
    });

    // ⏱ Normalize minutes (convert 60+ minutes -> hours)
    hrs += Math.floor(min / 60);
    min = min % 60;

    // Determine user type
    const isCandidate = usrType === "candidate";
    const isW2 = isCandidate && candidateEntity === "W2 Basis";
    const is1099 = !isCandidate || candidateEntity === "1099 Basis";

    // ----------------------------------------------
    // ⭐ FINAL ADJUSTMENT LOGIC
    // For 1099 → add (+adjustPlus + adjustMinus)
    // For W2 → use ADP deduction (negative)
    // ----------------------------------------------

    let adjValue = 0;

    if (isW2) {
      // W2 → only ADP deduction applies (negative)
      adjValue = -Math.abs(adpAmt);
    } else if (is1099) {
      // 1099 → adjustment = plus + minus
      // Note: adMinAmt is already negative (e.g. -0.62)
      adjValue = adPlusAmt + (-adMinAmt);
    }

    // ✔ Format adjustment: +X.XX or -X.XX or 0.00
    let adjDisplay = "";
    if (adjValue > 0) adjDisplay = "+" + adjValue.toFixed(2);
    else if (adjValue < 0) adjDisplay = adjValue.toFixed(2); // already negative
    else adjDisplay = "0.00";

    // NET CALCULATIONS
    const netW2 = (invAmt + adjValue).toFixed(2);
    const net1099 = (invAmt + adjValue).toFixed(2);

    return (
      <tr className="font-weight-bold">
        <th scope="row" colSpan={3}>Total</th>

        {/* Total Hours */}
        <td>{hrs}h {min}m</td>

        {/* Invoice Amount */}
        <td>{formatAmount(invAmt)}</td>

        {/* Adjustments */}
        <td>{formatAmount(adjDisplay)}</td>

        {/* Net Payable */}
        <td>{formatAmount(isW2 ? netW2 : net1099)}</td>

        {/* Paid Amount */}
        <td>{formatAmount(payAmt)}</td>
      </tr>
    );
  };




  const tmLogRptExportPDF = () => {
    const headers = [
      [
        "S.No.",
        "Year",
        "Month",
        "Total Hours",
        "Invoice Amount ($)",
        usrType === "candidate" && candidateEntity === "W2 Basis" ? "ADP(TAX) Adjustment" : "Adjustment",
        "Payment Amount ($)"
      ],
    ];
    let data = [];
    monthlyRpt.map((item, key) =>
      data.push([
        key + 1,
        item.year,
        months.filter((x) => x.id === item.month)[0].name,
        item.hours && parseFloat(item.hours).toFixed(2),
        item.totalAmount && parseFloat(item.totalAmount).toFixed(2),
        usrType === "candidate" && candidateEntity === "W2 Basis" ? item?.adpDeduction && "-" + parseFloat(item?.adpDeduction) :
          (item?.adjustPlus && "+" + parseFloat(item?.adjustPlus)) || (item?.adjustMinus > 0 && "-" + parseFloat(item?.adjustMinus)),
        item.paidAmount && parseFloat(item.paidAmount).toFixed(2),
      ])
    );
    setSelectedCol(headers);
    setSelectedColData(data);
    setPdfShowHide(true);
  };

  const handlepdfShowHide = () => {
    setPdfShowHide(false);
    setSelectedCol([]);
    setSelectedColData([]);
  };

  const getNetAmountWithAdjustment = (item) => {
    let netAmt = Number(item?.totalAmount) || 0;

    // Apply adjustments for non-candidates or 1099 candidates
    if (usrType !== "candidate" || candidateEntity === "1099 Basis") {
      if (item?.adjustPlus) netAmt += Number(item.adjustPlus);
      if (item?.adjustMinus) netAmt -= Number(item.adjustMinus);
    }

    // Candidate-specific deduction
    if (usrType === "candidate" && item?.adpDeduction) {
      netAmt -= Number(item.adpDeduction);
    }

    return netAmt.toFixed(2);
  };


  return (
    <React.Fragment>
      <div className="col-md-12 mt-2">
        <ul className="list-group">
          <li className="list-group-item">
            <div className="row">
              <div className="col-md-6">
                {/* <i className="fa fa-square wf-phase-box mr-2" aria-hidden="true"></i> */}
                <span className="h3">
                  {candidateEntity === "1099 Basis" && "Compensation"}
                  {candidateEntity === "W2 Basis" && "Pay"}
                  {candidateEntity === "C2C Basis" && "Invoice"} Reports
                </span>
              </div>
              <div className="col-md-6 text-right">
                <ReactHTMLTableToExcel
                  id="tmLogTable"
                  className="btn btn-sm btn-outline-default custom-excel-btn"
                  table="Invoice_Report"
                  filename="Invoice_Report"
                  sheet="Invoice_Report"
                  // buttonText=" Export to Excel"
                  buttonText={<><i className="fa fa-file-excel-o" style={{ marginRight: "6px" }} /> Export to Excel</>}
                />
                <button
                  type="button"
                  className="btn btn-sm btn-outline-dark"
                  disabled={monthlyRpt.length === 0}
                  onClick={tmLogRptExportPDF}
                >
                  <i className="fa fa-print" aria-hidden="true"></i> Generate PDF
                </button>
              </div>
            </div>


          </li>
          {usrType !== "candidate" && (
            <li className="list-group-item">
              <div className="row">
                <div className="col-md-8">
                  <select
                    name="candidate"
                    id="candidate"
                    className="form-control"
                    onChange={handleCandidateChange}
                    aria-label="Select Candidate"
                  >
                    <option value="">Select Candidate</option>
                    {candidateList.map((item) => (
                      <option value={item.performerid}>
                        {item.performername} {item.lastName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4">
                  <select
                    name="year"
                    id="year"
                    className="form-control"
                    onChange={handleChangeYear}
                    value={selectedYear}
                    aria-label="Select Year"
                  >
                    <option value="">Select Year</option>
                    {years.filter(x => x.name <= (new Date().getFullYear())).map((item) => (
                      <option value={item.name}>{item.name}</option>
                    ))}
                  </select>
                </div>
              </div>
            </li>
          )}
          <li className="list-group-item">
            <div className="table-responsive">
              <table
                id="Invoice_Report"
                className="table align-items-center table-flush table-hover table-striped border"
              >
                <thead className="thead-light">
                  <tr>
                    <th>S.No.</th>
                    <th>Year</th>
                    <th>Month</th>
                    <th>Total Hours</th>
                    <th>Amount ($)</th>
                    <th>
                      {usrType === "candidate" && candidateEntity === "W2 Basis"
                        ? "ADP (TAX) Adjustment"
                        : "Adjustment"}
                    </th>
                    <th>Net Amount ($)</th>
                    <th>Received Amount ($)</th>
                  </tr>
                </thead>

                <tbody>
                  {monthlyRpt.map((item, index) => {
                    const monthName =
                      months.find((x) => x.id === item.month)?.name || "N/A";

                    const amount = Number(item.totalAmount).toFixed(2);
                    const paid = Number(item.paidAmount).toFixed(2);

                    const isCandidate = usrType === "candidate";
                    const isW2 = isCandidate && candidateEntity === "W2 Basis";
                    const is1099 = !isCandidate || candidateEntity === "1099 Basis";

                    let adjustmentText = "";

                    if (isW2 && item.adpDeduction) {
                      adjustmentText = `-${Number(item.adpDeduction).toFixed(2)}`;
                    } else if (is1099) {
                      if (item.adjustPlus) {
                        adjustmentText = `+${Number(item.adjustPlus).toFixed(2)}`;
                      } else if (item.adjustMinus) {
                        adjustmentText = `-${Number(item.adjustMinus).toFixed(2)}`;
                      }
                    }

                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.year}</td>
                        <td>{monthName}</td>

                        {/* Total hours */}
                        <td>
                          {item.hours}h {item.minutes}m
                        </td>

                        {/* Invoice amount */}
                        <td>{formatAmount(amount)}</td>

                        {/* Adjustment */}
                        <td>{formatAmount(adjustmentText)}</td>

                        {/* Net Amount */}
                        <td>{formatAmount(getNetAmountWithAdjustment(item))}</td>

                        {/* Paid Amount */}
                        <td>{formatAmount(paid)}</td>
                      </tr>
                    );
                  })}

                  {getTotalRows()}
                </tbody>
              </table>
            </div>
          </li>

        </ul>
      </div>
      <GeneratePdf
        handlepdfShowHide={handlepdfShowHide}
        pdfShowHide={pdfShowHide}
        selectedCol={selectedCol}
        selectedColData={selectedColData}
      ></GeneratePdf>
    </React.Fragment>
  );
}

export default CustomReport;
